import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { format, addDays } from "date-fns";
import "./TourSlider.css"; // Thêm CSS tùy chỉnh nếu cần

const TourDetailInfoBooking = ({ selectedTour, userInfo }) => {
  const navigate = useNavigate();
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const [startDate, setStartDate] = useState(tomorrow);
  const [endDate, setEndDate] = useState(
    addDays(startDate, selectedTour.numberDay)
  );
  const location = useLocation();
  const { startDateOrder, endDateOrder, quantityOrder } = location.state || {};
  const [quantity, setQuantity] = useState(1); // Khởi tạo với 1

  useEffect(() => {
    setEndDate(addDays(startDate, selectedTour.numberDay - 1));
  }, [startDate, selectedTour.numberDay]);

  useEffect(() => {
    if (startDateOrder) {
      setStartDate(startDateOrder);
    }
    if (endDateOrder) {
      setEndDate(endDateOrder);
    }
    // Ưu tiên quantityOrder nếu có, nếu không thì set theo isPersonalizedTour
    if (quantityOrder) {
      setQuantity(+quantityOrder);
    } else if (
      selectedTour.isPersonalizedTour &&
      selectedTour.maxParticipants
    ) {
      setQuantity(selectedTour.maxParticipants); // Fix cứng quantity khi là tour cá nhân hóa
    } else {
      setQuantity(1); // Đặt lại về 1 cho tour thường nếu không có quantityOrder
    }
  }, [
    startDateOrder,
    endDateOrder,
    quantityOrder,
    selectedTour.isPersonalizedTour,
    selectedTour.maxParticipants,
  ]);

  const handleDecrease = () => {
    if (!selectedTour.isPersonalizedTour && quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const handleIncrease = () => {
    if (
      !selectedTour.isPersonalizedTour &&
      quantity < selectedTour.maxParticipants
    ) {
      setQuantity((prev) => prev + 1);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!userInfo) {
      toast.error("Vui lòng đăng nhập để đặt tour!");
      return;
    }
    if (userInfo.phoneNumber === null || userInfo.phoneNumber === "") {
      toast.error("Vui lòng cập nhật số điện thoại của bạn để đặt tour!");
      return;
    }
    if (userInfo.address === null || userInfo.address === "") {
      toast.error("Vui lòng cập nhật địa chỉ của bạn để đặt tour!");
      return;
    }
    const formattedStartDate = format(startDate, "yyyy-MM-dd");
    const formattedEndDate = format(endDate, "yyyy-MM-dd");

    navigate(
      `/booking?tourId=${selectedTour.tourId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}&quantity=${quantity}`
    );
  };

  return (
    <div className="card shadow-none">
      <div className="card-body">
        <div className="banner-form">
          <form onSubmit={handleSubmit}>
            <div className="form-info border-0">
              <div className="form-item border rounded p-3 mb-3 w-100">
                <label className="form-label fs-14 text-default mb-0">
                  Từ ngày
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={setStartDate}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  minDate={tomorrow}
                />
                <p className="fs-12">{format(startDate, "EEEE")}</p>
              </div>
              <div className="form-item border rounded p-3 mb-3 w-100">
                <label className="form-label fs-14 text-default mb-0">
                  Đến ngày
                </label>
                <input
                  type="text"
                  className="form-control datetimepicker"
                  value={format(endDate, "dd-MM-yyyy")}
                  readOnly
                />
                <p className="fs-12">{format(endDate, "EEEE")}</p>
              </div>
              <div className="card shadow-none mb-3">
                <div className="card-body p-3 pb-0">
                  <div className="border-bottom pb-2 mb-2">
                    <h6>Chi tiết</h6>
                  </div>
                  <div className="custom-increment">
                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <label className="form-label text-gray-9 mb-0">
                        Số lượng
                      </label>
                      <div className="custom-increment">
                        <div className="input-group">
                          <span className="input-group-btn float-start">
                            <button
                              type="button"
                              className="quantity-left-minus btn btn-light btn-number"
                              onClick={handleDecrease}
                              disabled={selectedTour.isPersonalizedTour} // Vô hiệu hóa nếu là tour cá nhân hóa
                            >
                              <span>
                                <i className="isax isax-minus"></i>
                              </span>
                            </button>
                          </span>

                          <input
                            type="text"
                            name="quantity"
                            className="input-number text-center"
                            value={quantity.toString().padStart(2, "0")}
                            readOnly
                          />

                          <span className="input-group-btn float-end">
                            <button
                              type="button"
                              className="quantity-right-plus btn btn-light btn-number"
                              onClick={handleIncrease}
                              disabled={selectedTour.isPersonalizedTour} // Vô hiệu hóa nếu là tour cá nhân hóa
                            >
                              <span>
                                <i className="isax isax-add"></i>
                              </span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {selectedTour?.status === 3 ? (
              <span className="badge badge-sm bg-warning rounded-pill ms-2 d-block text-center fs-14">
                <i className="isax isax-clock me-1"></i>Đang chờ xử lý
              </span>
            ) : selectedTour?.status === 5 ? (
              <span className="badge badge-sm bg-danger rounded-pill ms-2 d-block text-center fs-14">
                <i className="isax isax-close-circle me-1"></i>Đã từ chối
              </span>
            ) : (
              <button
                type="submit"
                className="btn btn-primary btn-lg search-btn ms-0 w-100 fs-14"
              >
                Đặt ngay
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default TourDetailInfoBooking;
